// Remove first and last '/' char, if present
// https://regex101.com/r/ENqrFy/1
var SLASHES_REGEX = /^\/|\/+$/g;
export var defaultKeyGenerator = function (_a) {
    var _b = _a.baseURL, baseURL = _b === void 0 ? '' : _b, _c = _a.url, url = _c === void 0 ? '' : _c, nullableMethod = _a.method, params = _a.params, id = _a.id;
    if (id)
        return String(id);
    // Remove trailing slashes
    baseURL = baseURL.replace(SLASHES_REGEX, '');
    url = url.replace(SLASHES_REGEX, '');
    var method = (nullableMethod === null || nullableMethod === void 0 ? void 0 : nullableMethod.toLowerCase()) || 'get';
    var jsonParams = params ? JSON.stringify(params, Object.keys(params).sort()) : '{}';
    return "".concat(method, "::").concat(baseURL + (url && baseURL ? '/' : '') + url, "::").concat(jsonParams);
};
